import { render, staticRenderFns } from "./ovrz3.vue?vue&type=template&id=b64f45b2"
import script from "./ovrz3.vue?vue&type=script&lang=js"
export * from "./ovrz3.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports